/**
 * Registers the 'changeKeyboardLanguage' directive to the provided module.
 * This directive handles the positioning of the dropdown menu based on the 'dropdownPos' attribute.
 * 
 * @param {object} module - The AngularJS module to which the directive will be registered.
 */
export default function registerChangeKeyboardLanguageDirective(module) {
    module.directive('changeKeyboardLanguage', function($timeout) {
        return {
            restrict: 'E', // Restricts the directive to element usage only.
            replace: true, // Replaces the HTML element with the template.
            scope: {
                dropdownPos: '@', // Binds the dropdownPos attribute as a string.
                inSheet: '=', // Two-way binds the inSheet attribute.
                inOverview: '=' // Two-way binds the inOverview attribute.
            },
            templateUrl: '/views/ib/components/changeKeyboardLanguage/changeKeyboardLanguage.html', // URL of the template to be used by the directive.
            controller: 'ChangeKeyboardLanguageDirectiveController', // Controller associated with the directive.
            link: function(scope, element, attr) {
                // Check if the dropdown should be positioned to the left.
                if (scope.dropdownPos === 'left') {
                    $timeout(function() {
                        // Calculate and set the left CSS property of the dropdown menu.
                        element.find('.dropdown-menu').css({
                            left: -(element.find('.dropdown-menu').width() - element.find('.select-keyboard-btn').outerWidth()) + 'px'
                        });
                    }, 0); // Timeout delay to ensure DOM is ready.
                }
            }
        };
    });
}